import { TrackJS } from "trackjs";

export const get = async (path: string) => {
  let response;
  try {
    response = await fetch(`${path}`);
  } catch (error) {
    TrackJS.track(error);
    return undefined;
  }
  const text = await response.text();
  try {
    return JSON.parse(text);
  } catch (error) {
    TrackJS.track("Got invalid JSON: " + text);
    return undefined;
  }
};